import React from 'react'
import { INFTHistoryItem } from '../../../models/INFTHistory'
import NFTActivtyFormatDetector from '../../../nftFormats/NFTFormatDetector/Activity/NFTActivtyFormatDetector'

export default function NFTHistoryItem(props: INFTHistoryItem) {
  return <NFTActivtyFormatDetector chainId={props.chainId} historyItem={props.historyItem} />
}
